import {
  FileExcelOutlined,
  FileOutlined,
  FilePdfOutlined,
  FileWordOutlined,
} from '@ant-design/icons'

export function FileIcon({ fileName }) {
  const split = fileName.split('.')
  switch (split[split.length - 1]) {
    case 'pdf':
      return <FilePdfOutlined />
    case 'doc':
    case 'docx':
      return <FileWordOutlined />
    case 'xls':
    case 'xlsx':
      return <FileExcelOutlined />
    default:
      return <FileOutlined />
  }
}
